import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import HeartBrokenRoundedIcon from '@mui/icons-material/HeartBrokenRounded';
import { useCallback } from 'react';
import { createFriendAddOutbound } from '../../api/outbound/friendsOutbounds';
import { MenuItemContainer } from '../../components/menuItemContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { thunkSetActivePanel } from '../../redux/actions/panelsActions';
import { useAppDispatch } from '../../redux/store';
export const PlayerInfoFriendshipMenuItem = ({ playerIdName, isFriend, closeMenu }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickRemoveFriend = useCallback(() => {
        dispatch(addMessageBox({ type: 'remove-friend', username: playerIdName.name }));
    }, [dispatch, playerIdName.name]);
    const onClickAddFriend = useCallback(() => {
        socketSend(createFriendAddOutbound(playerIdName.name));
        dispatch(thunkSetActivePanel('friends', socketSend));
    }, [dispatch, playerIdName.name, socketSend]);
    if (!isFriend) {
        return (_jsx(MenuItemContainer, { label: 'Add Friend', svgIconComponent: AddRoundedIcon, onClick: onClickAddFriend, closeMenu: closeMenu }));
    }
    else {
        return (_jsx(MenuItemContainer, { label: 'Unfriend', svgIconComponent: HeartBrokenRoundedIcon, onClick: onClickRemoveFriend, closeMenu: closeMenu }));
    }
};
